import { render } from "./SearchRender.vue?vue&type=template&id=2adb377c"
import script from "./SearchRender.vue?vue&type=script&language=ts&lang=js"
export * from "./SearchRender.vue?vue&type=script&language=ts&lang=js"
script.render = render

export default script